import { yupResolver } from '@hookform/resolvers/yup';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';

import { useUpdateOrgaCommentMutation } from '../../../../event/hooks/useUpdateOrgaCommentMutation';

interface OrgaCommentInputs {
  orgaComment: string;
}

const schema = yup
  .object({
    orgaComment: yup.string().required('Le commentaire est requis'),
  })
  .required();

export const useCommentDialog = ({
  defaultOrgaComment,
  eventId,
  onClose,
  userId,
}: {
  eventId: string;
  userId: string;
  onClose: () => void;
  defaultOrgaComment: string;
}) => {
  const { updateOrgaComment } = useUpdateOrgaCommentMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<OrgaCommentInputs>({
    resolver: yupResolver(schema),
    defaultValues: {
      orgaComment: defaultOrgaComment,
    },
  });

  const onValid: SubmitHandler<OrgaCommentInputs> = (data) => {
    updateOrgaComment({
      eventId,
      userId,
      orgaComment: data.orgaComment,
    });
    onClose();
  };

  const onSubmit = handleSubmit(onValid);

  return {
    onSubmit,
    errors,
    register,
  };
};
